
<template>
  <i :class="classes" :style="styles"></i>
</template>

<script>
  const prefixCls = 'fps-icon'

  export default {
    name: 'FpsIcon',
    componentName: 'FpsIcon',
    props: {
      type: String,
      size: [Number, String],
      color: String,
      fontStyle: {
        type: String,
        default: 'normal',
      }
    },
    computed: {
      classes () {
        return `${prefixCls} ${prefixCls}-${this.type}`
      },
      styles () {
        let style = {}
        style['font-style'] = `normal`
        if (this.size) {
          style['font-size'] = `${this.size}px`
        }
        if (this.fontStyle) {
          style['font-style'] = this.fontStyle
        }
        if (this.color) {
          style.color = this.color
        }
        return {
          ...style,
          lineHeight: 1,
        }
      }
    }
  }
</script>

<style lang="scss">
  @import './iconfont.css';
</style>
